import { useContext } from 'react';
import { MetalClientContext } from '../context';
import { useCallbackOne as useCallback } from 'use-memo-one';
const submitMetric = (client, metric) => {
  if (client) {
    Promise.resolve(client).then(client => client.metric.submit(metric));
  }
};
export const useMetrics = () => {
  const {
    metalClient,
    page
  } = useContext(MetalClientContext);
  return {
    submitMetric: useCallback(metric => submitMetric(metalClient, metric), [metalClient]),
    page
  };
};